import { css } from "emotion";
import { Component } from "preact";
import { connect } from "react-redux";
import Content from "../../../components/Content";
import Modal from "../../../components/Modal";
import {
  loadAttendeeProfileData,
  setToken
} from "../../../state/actions/attendeeProfileActions";
import TicketList from "../../conferences/TicketList";
import Header from "../editOrder/Header";
import AttendeeProfile from "./AttendeeProfile";

const pageStyle = css({
  position: "relative",
  maxWidth: 1040,
  margin: "0px auto",
  background: "#fff",
  boxShadow: "0 1px 3px 0 rgba(9,30,66,0.13), 0 0 1px 0 #F1F1F1",
  borderTop: "none"
});

class EditTicket extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: props.redirect
    };
  }
  componentWillMount() {
    const {
      loadAttendeeProfileData,
      orderId,
      eventId,
      token,
      attendeeProfileId,
      setToken
    } = this.props;
    loadAttendeeProfileData(orderId, eventId, attendeeProfileId, token);
    setToken(token);
  }

  render({
    order,
    event,
    token,
    orderId,
    eventId,
    attendeeProfileId,
    attendeeProfile
  }) {
    const { showModal } = this.state;
    const routeParams = {
      token,
      orderId,
      eventId,
      attendeeProfileId
    };
    const eventLoaded = event.data && !event.loading;
    const profileLoaded = attendeeProfile.profile;
    if (!eventLoaded || !profileLoaded) {
      return null;
    }
    let detailsAdditionQuestions =
      event.data.additionalQuestions && event.data.additionalQuestions.length
        ? event.data.additionalQuestions
        : [];
    detailsAdditionQuestions = detailsAdditionQuestions.map(q => {
      if (q.type === "multiSelect" && q.options && q.options.length) {
        q.options = q.options.map(o => {
          const newOption = o.label
            ? {
                ...o
              }
            : {
                ...o,
                id: o._id,
                label: o.value,
                value: false
              };
          return newOption;
        });
      }
      return q;
    });

    const ticketsGroupedByType = Object.values(
      order.data.tickets.reduce((map, ticket) => {
        if (!map[ticket.ticketTypeId]) {
          map[ticket.ticketTypeId] = {
            tickets: [],
            ticketTypeName: ticket.ticketTypeName
          };
        }
        map[ticket.ticketTypeId].tickets.push(ticket);
        return map;
      }, {})
    );

    const ticketsGroupedByAttendeeProfile = order.data.tickets.reduce(
      (map, ticket) => {
        if (!ticket.attendeeProfileId) {
          map["unassigned"].push(ticket);
        } else {
          if (!map[ticket.attendeeProfileId]) {
            map[ticket.attendeeProfileId] = [];
          }
          map[ticket.attendeeProfileId].push(ticket);
        }
        return map;
      },
      { unassigned: [] }
    );

    const { profile } = attendeeProfile;
    const profileLookup = { [profile._id]: profile };
    const profiles = [profile];
    return (
      <div
        style={{
          background: "#F9F9FA", //this.getBackground(event, theme, background),
          backgroundSize: "cover", ///backgroundSize,
          paddingBottom: 12,
          padding: 7
        }}
      >
        <Modal
          showModal={showModal}
          closeHandler={() => this.setState({ showModal: false })}
          title={"Unanswered questions"}
          contents={
            <p>
              There are unanswered questions which need to be answered before
              you can access your tickets.
            </p>
          }
        />
        <div style={{ maxWidth: 1040, margin: "0px auto" }}>
          <Header />
        </div>
        <div className={pageStyle}>
          <Content style={{ padding: "20px 24px", marginTop: 28 }}>
            <AttendeeProfile routeParams={routeParams} />
          </Content>
        </div>
        <div className={pageStyle}>
          <Content style={{ padding: "20px 24px", marginTop: 28 }}>
            <h2 class="sub-header" style={{ fontWeight: 600 }}>
              Your Tickets
            </h2>
            <form>
              {ticketsGroupedByType.map((ticketTypes, i) => {
                return (
                  <TicketList
                    profileLookup={profileLookup}
                    profiles={profiles}
                    {...ticketTypes}
                    index={i}
                    ticketsGroupedByAttendeeProfile={
                      ticketsGroupedByAttendeeProfile
                    }
                    disableReassigning={true}
                    token={token}
                  />
                );
              })}
            </form>
          </Content>
        </div>
      </div>
    );
  }
}

export default connect(
  (state, ownProps) => {
    return {
      event: state.event,
      order: state.order,
      attendeeProfile: state.attendeeProfile
    };
  },
  {
    loadAttendeeProfileData,
    setToken
  }
)(EditTicket);



// WEBPACK FOOTER //
// ./routes/public/editTicket/EditTicket.js